import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui';
import { Company } from '@cyborg-monorepo/hunter/common';
import { NgChartsModule } from 'ng2-charts';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MomentModule } from 'ngx-moment';
import { Observable } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { ReleaseModule } from './changelog/release.module';
import { ReleaseService } from './changelog/release.service';
import { AuthService } from './auth/auth.service';
import { FeatureFlagService } from './helpers/feature-flag.service';
import { ResearchModule } from './modules/research/research.module';
import { SettingsModule } from './modules/settings/settings.module';
import { FooterComponent } from './modules/shared/components/footer/footer.component';
import { HeaderComponent } from './modules/shared/components/header/header.component';
import { UserService } from './modules/shared/services/user.service';
import { SharedModule } from './modules/shared/shared.module';
import { FourOhFourComponent } from './screens/404/404.component';
import { LoginComponent } from './screens/portal/login/login.component';
import { NewPasswordComponent } from './screens/portal/new-password/new-password.component';
import { PortalComponent } from './screens/portal/portal.component';
import { ResetPasswordComponent } from './screens/portal/reset-password/reset-password.component';
import { PremiumGateComponent } from './screens/premium-gate/premium-gate.component';
import { ReactivateDialogComponent } from './screens/premium-gate/reactivate-dialog/reactivate-dialog.component';
import { PrivacyComponent } from './screens/privacy-policy/privacy.component';
import { TrialGateComponent } from './screens/trial-gate/trial-gate.component';
import { TrackingModule } from './tracking/tracking.module';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { ContactUsComponent } from './screens/customer-support/contact.component';
import { BadgeComponent, ButtonComponent, DialogService, ErrorComponent, HyperkitComponent, IconComponent, InputComponent, LinkComponent, SearchInputComponent, TextAreaComponent, ThemeService, TypographyComponent } from '@hyperkit';
import { FooterOnlyLayoutComponent } from './layouts/footer-only-layout/footer-only-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { NewHuntDialogComponent } from './modules/shared/components/dialogs/new-hunt-dialog/new-hunt-dialog.component';
import { ArchiveHuntGuard } from './modules/hunt/archived-hunt.guard';
import { HuntWorkbenchComponent } from './modules/hunt-redesign/hunt-workbench/hunt-workbench.component';
import { HuntEditReportComponent } from './modules/hunt-redesign/hunt-edit-report/hunt-edit-report.component';
import { HuntFinalReportComponent } from './modules/hunt-redesign/hunt-final-report/hunt-final-report.component';
@NgModule({
  declarations: [
    AppComponent,
    PortalComponent,
    LoginComponent,
    NewPasswordComponent,
    ResetPasswordComponent,
    HeaderComponent,
    ContactUsComponent,
    PrivacyComponent,
    TrialGateComponent,
    ReactivateDialogComponent,
    PremiumGateComponent,
    FourOhFourComponent,
    FooterComponent,
    FooterOnlyLayoutComponent,
    MainLayoutComponent,
    // NewHuntDialogComponent,
  ],
  imports: [
    SharedModule,
    HyperkitComponent,
    ButtonComponent,
    TypographyComponent,
    IconComponent,
    BadgeComponent,
    SearchInputComponent,
    LinkComponent,
    InputComponent,
    TextAreaComponent,
    BrowserAnimationsModule,
    CyborgUIModule,
    ErrorComponent,
    HttpClientModule,
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    MomentModule,
    NgChartsModule,
    ImageCropperModule,
    AuthModule,
    TrackingModule,
    SettingsModule,
    ResearchModule,
    FeatureToggleModule,
    ReleaseModule,
    // Hunt Module Redesign
    HuntWorkbenchComponent,
    HuntEditReportComponent,
    HuntFinalReportComponent
  ],
  providers: [
    UserService,
    ThemeService,
    FeatureFlagService,
    ReleaseService,
    DialogService,
    ArchiveHuntGuard,
    {
      provide: APP_INITIALIZER,
      useFactory:
        (featureFlagsService: FeatureFlagService) => (): Observable<Company> =>
          featureFlagsService.loadFeatureFlags(),

      deps: [FeatureFlagService],
      multi: true,
    },
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => (): void =>
        authService.checkStatus('premium-gate'),
      deps: [AuthService],
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
